import LayoutGallery from './LayoutGallery'
import LayoutTab from './LayoutTab'

export { LayoutGallery, LayoutTab }
